$(function () {
    if ( $( ".acf_numdays" ).length ) {

        console.log("initA");
        var $numdays = $( ".acf_numdays input" );
        var $text = $( ".acf_numdays .instruction");
        var $from = $(".datefrom input");
        var $to = $("#field_4_38 input");
        var fromVal = $from.val();
        var toVal = $to.val();
        var val = $numdays.val();

        initVal();

        checkVal();

        $numdays.on('input', checkVal);
        $numdays.on('change', checkVal);
        $from.on('input', checkVal);
        $from.on('change', checkVal);

        function initVal() {
            if (toVal) {
                var diff = moment(toVal, "DD.MM.YYYY").diff(moment(fromVal, "DD.MM.YYYY"), 'days');
                console.log("diff: "+diff);
                $numdays.val(diff);
            } else {
                console.log("no ToVal");
            }
        }

        function checkVal() {
            val = $numdays.val();

            if (isInt(val)) {
                if (val > 30) {
                    $numdays.val(30);
                } else if (val < 1) {
                    $numdays.val(1);
                }
            } else {
                if (val !== '') {
                    $numdays.val(1);
                } else {
                    val = 0;
                }
            }
            updateToDate();
        }

        function updateToDate() {
            val = $numdays.val();
            fromVal = $from.val();
            if (fromVal && val) {
                var toDate = moment(fromVal, "DD.MM.YYYY").add('days', val).format("DD.MM.YYYY");
                console.log('toDate: '+toDate);
                $to.val(toDate);
                $text.text("Letzer Tag: "+toDate);
            }

        }

        function isInt(value) {
            return !isNaN(value) &&
                parseInt(Number(value)) == value &&
                !isNaN(parseInt(value, 10));
        }
    }
});
